module.exports = __webpack_public_path__ + "img/seafunproject.22975df8.webp";